import { render, staticRenderFns } from "./import.vue?vue&type=template&id=2c0c8a4e&scoped=true&"
import script from "./import.ts?vue&type=script&lang=ts&"
export * from "./import.ts?vue&type=script&lang=ts&"
import style0 from "./import.vue?vue&type=style&index=0&id=2c0c8a4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0c8a4e",
  null
  
)

export default component.exports